var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70007 32C7.10007 32 5.30007 29.7 4.00007 27.7C0.700074 22.6 7.41482e-05 16.2 2.40007 12.5C4.00007 10 6.60007 8.5 9.10007 8.5C10.4001 8.5 11.5001 8.9 12.4001 9.2C13.1001 9.5 13.8001 9.7 14.5001 9.7C15.1001 9.7 15.6001 9.5 16.3001 9.2C17.2001 8.9 18.3001 8.5 19.8001 8.5C22.0001 8.5 24.3001 9.7 25.9001 11.7C26.1001 11.9 26.2001 12.2 26.1001 12.5C26.0001 12.8 25.9001 13 25.6001 13.2C23.8001 14.2 22.8001 16 23.0001 18C23.1001 20.1 24.4001 21.8 26.3001 22.5C26.6001 22.6 26.8001 22.8 26.9001 23.1C27.0001 23.4 27.0001 23.6 26.9001 23.9C26.2001 25.4 25.9001 26.1 25.0001 27.4C23.5001 29.6 21.7001 31.9 19.3001 31.9C18.2001 31.9 17.5001 31.6 16.9001 31.3C16.3001 31 15.7001 30.7 14.5001 30.7C13.4001 30.7 12.8001 31 12.1001 31.3C11.5001 31.7 10.8001 32 9.70007 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7003 8.6999C13.6003 8.6999 13.6003 8.6999 13.5003 8.6999C13.0003 8.6999 12.6003 8.2999 12.5003 7.8999C12.2003 6.1999 12.8003 4.1999 14.1003 2.5999C15.3003 1.0999 17.3003 0.0999023 19.1003 -0.100098C19.6003 -0.100098 20.1003 0.199902 20.2003 0.799902C20.5003 2.5999 19.9003 4.4999 18.6003 6.0999C17.5003 7.6999 15.5003 8.6999 13.7003 8.6999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.542dd0f44d543cfe956c401fd95a2c64.svg";
export { ForwardRef as ReactComponent };